module.exports = __webpack_public_path__ + "static/media/ss-adivinhe.8cf090f2.png";